import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/inventory")({
  component: InventoryLayout,
});

/**
 * Inventory domain layout.
 * Domain-level navigation is handled by the central navigation config.
 * Only entity-level routes (e.g., /inventory/equipment/$id) should use useSidebarConfig.
 */
function InventoryLayout() {
  return (
    <div className="container mx-auto py-6 w-full max-w-[120rem] h-full overflow-auto px-4">
      <Outlet />
    </div>
  );
}
